import { CategoryInterface } from '../../../services/exports/Interfaces';
import { CategoryType } from '../../../services/exports/Constants';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../store/types';
import { useTranslation } from 'react-i18next';
import useMobileApp from '../../../hooks/mobile-app/useMobileApp';

const useGiftCardCategory = () => {
  const isGiftCardEnabled = useSelector((state: StoreInterface) => state.initialData.franchise?.is_gift_cards_enabled);
  const hasStorefront = useSelector((state: StoreInterface) => !!state.initialData.company?.has_storefront);
  const { t } = useTranslation(null, { keyPrefix: 'Features:GiftCards:useGiftCardCategory' });
  const { isMobileApp } = useMobileApp();

  if (isMobileApp) {
    return;
  }

  if (!isGiftCardEnabled || hasStorefront) {
    return;
  }

  const giftCardCategoryProduct = {};
  const giftCardsCategory: CategoryInterface<any> = {
    id: -100,
    menu_id: null,
    menu_ids: [],
    type: CategoryType.GiftCards,
    name: t('category_name'),
    image_url: null,
    product_ids: [],
    products: [giftCardCategoryProduct],
  };

  return giftCardsCategory;
};

export default useGiftCardCategory;
